module.exports = __webpack_public_path__ + "static/media/31.50be8ec2.jpg";